import React, { useState } from "react";
import { Form, Input, Button, Card, Typography, message, Space } from "antd";
import { UserOutlined, LockOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "../store/authStore";
import { authService, type LoginRequest } from "../services/authService";

const { Title, Text } = Typography;

const LoginPage: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { login } = useAuthStore();
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (values: LoginRequest) => {
    setIsLoading(true);
    try {
      const response = await authService.login(values);

      login(response.data.user, response.data.accessToken);

      if (response?.data?.user?.role === "therapist") {
        message.success("ເຂົ້າສູ່ລະບົບສຳເລັດ");
        navigate("/attendance/employee");
      } else {
        message.success("ເຂົ້າສູ່ລະບົບສຳເລັດ");
        navigate("/");
      }
    } catch (error: any) {
      // Force แสดง message
      setTimeout(() => {
        message.error(error.response?.data?.message || "ກະລຸນາລອງໃໝ່ອີກຄັ້ງ");
      }, 0);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "20px",
      }}
    >
      <Card
        style={{
          width: "100%",
          maxWidth: 400,
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Space
          direction="vertical"
          size="large"
          style={{ width: "100%", textAlign: "center" }}
        >
          <div>
            <Title level={2} style={{ margin: 0, color: "#1890ff" }}>
              ລະບົບຈັດການສະປາລາວປະຍຸກ
            </Title>
            <Text type="secondary">ກະລຸນາເຂົ້າສູ່ລະບົບເພື່ອໃຊ້ງານ</Text>
          </div>

          <Form
            form={form}
            name="login"
            onFinish={handleSubmit}
            layout="vertical"
            size="large"
          >
            <Form.Item
              name="employeeId"
              label="ລະຫັດພະນັກງານ"
              rules={[{ required: true, message: "ກະລຸນາປ້ອນລະຫັດພະນັກງານ" }]}
            >
              <Input prefix={<UserOutlined />} placeholder="ລະຫັດພະນັກງານ" />
            </Form.Item>

            <Form.Item
              name="password"
              label="ລະຫັດຜ່ານ"
              rules={[{ required: true, message: "ກະລຸນາປ້ອນລະຫັດຜ່ານ" }]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="ລະຫັດຜ່ານ"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                loading={isLoading}
                style={{ width: "100%" }}
              >
                ເຂົ້າສູ່ລະບົບ
              </Button>
            </Form.Item>
          </Form>
        </Space>
      </Card>
    </div>
  );
};

export default LoginPage;
